export default __webpack_public_path__ + "static/media/esg.1b3ed640.svg";